import { FC } from 'react';
import classnames from 'classnames';

import styles from './PdpSharedDivider.scss';

export const PdpSharedDivider: FC<{
    isViewportWidth?: boolean;
    size?: 'xxxSmall' | 'xSmall';
}> = ({ isViewportWidth = false, size = 'xxxSmall' }) => {
    return (
        <div
            className={classnames(styles[size], {
                [styles.viewportWidth]: isViewportWidth,
            })}
        />
    );
};
